import { useCallback, useMemo, useState } from 'react';
import type { InstitutionCorrespondence } from '../../../types';

export function useSubjectManagement(
  allCorrespondence: InstitutionCorrespondence[]
) {
  // Default subject derived from correspondence — used until the user edits.
  const derivedSubject = useMemo(() => {
    if (allCorrespondence.length === 0) return '';
    const sentCorrespondences = allCorrespondence.filter(
      (c) => (c.status as string).toLowerCase() === 'sent'
    );
    const relevantCorr =
      sentCorrespondences.length > 0
        ? sentCorrespondences[sentCorrespondences.length - 1]
        : allCorrespondence[0];
    return relevantCorr.subject ?? '';
  }, [allCorrespondence]);

  const [userSubject, setUserSubject] = useState<string | null>(null);
  const messageSubject = userSubject ?? derivedSubject;
  const setMessageSubject = useCallback(
    (subject: string) => setUserSubject(subject),
    []
  );

  return { messageSubject, setMessageSubject };
}
